// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"loading_spinnerContainer__7WXhR","spinner":"loading_spinner__3eiHV"};